import ApiRoot from './fetcher'
import apis from '../config/api-config'

export const AuthVerificationVerificationCode = async (params: any) => {
  try {

    let res = await ApiRoot({ url: apis.graphql_auth }).users().authVerificationVerificationCode(params)
    return res
  } catch (e) {
    console.log(e)
    return []
  }
}
export const authResetPassword = async (params: any) => {
  try {

    let res = await ApiRoot({
      url: apis.seller_center
    }).users().authResetPassword(params)
    return res || false
  } catch (e) {
    console.log(e)
    return false
  }
}

export const authSendMessage = async (input: any) => {
  try {
    // debugger
    let res = await ApiRoot({
      url: apis.seller_center
    }).users().authSendMessage(input)
    return res || false
  } catch (e) {
    return false
  }
}
